<template>
  <v-dialog :value="showModal" @input="updateShowModal" max-width="650">
    <v-card>
      <v-card-title>{{ trans(isUpdate ? 'misc.editMiscBooking' : 'misc.newMiscBooking') }}</v-card-title>
      <v-divider/>
      <v-card-text>
        <global-validation-errors class="mt-4" :value="validationErrors" />
        <v-row>
          <v-col cols="12">
            <v-text-field
                :error-messages="validationErrors['description']"
                :label="trans('misc.description')"
                v-model="misc.description"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <currency-input
                :error-messages="validationErrors['price']"
                :label="trans('misc.priceGross')"
                v-model="misc.price"
                currency="EUR"
                @change="misc.priceNet = null"
            ></currency-input>
          </v-col>
          <v-col cols="6">
            <v-checkbox
                :label="trans('misc.addCashflow')"
                :true-value="true"
                :false-value="false"
                v-model="misc.addCashflow"
                :disabled="disableAddCashflow"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer></v-spacer>
        <cancel-button @click="updateShowModal(false)"></cancel-button>
        <save-button :loading="loading" @click="sendRequest"></save-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CancelButton from './CancelButton'
import {LocaleUtils} from '../utils/locale-utils';
import {RouterUtils} from '../utils/router-utils';
import CurrencyInput from '@/components/CurrencyInput';
import {MiscApi} from '@/api/misc-api';
import {MainUtils} from '@/utils/main-utils';
import GlobalValidationErrors from '@/components/GlobalValidationErrors';
import SaveButton from './SaveButton';

export default {
  name: 'BookingMiscAdditModal',
  mixins: [
    MainUtils,
    LocaleUtils,
    RouterUtils
  ],
  components: {SaveButton, GlobalValidationErrors, CurrencyInput, CancelButton},
  props: {
    showModal: {
      type: Boolean
    },
    initialBookingMisc: {
      type: Object,
      required: false,
    },
    disableAddCashflow: {
      type: Boolean,
      default () {
        return false;
      }
    }
  },
  data () {
    return {
      loading: false,
      misc: this.getDefaultMisc(),
      validationErrors: {}
    }
  },
  computed: {
    isUpdate() {
      return this.initialBookingMisc && !!this.initialBookingMisc.miscId;
    }
  },
  methods: {
    getDefaultMisc() {
      return {
        bookingId: null,
        description: null,
        price: null,
        addCashflow: !this.disableAddCashflow
      }
    },
    convertMisc(bookingMisc) {
      if(bookingMisc == null) {
        return {};
      }

      let misc = JSON.parse(JSON.stringify(bookingMisc))

      misc.booking = misc.booking ? misc.booking.id : null;

      return misc;
    },
    sendRequest() {
      if(!this.loading) {
        this.loading = true;
        let request = this.isUpdate ?
            MiscApi.updateBookingMisc(this.initialBookingMisc.miscId, this.misc) :
            MiscApi.createBookingMisc(this.misc);

        request.then(() => {
              this.$emit('success');
              this.updateShowModal(false);
            })
            .catch((response) => this.validationErrors = this.getValidationErrors(response))
            .finally(() => {
              this.loading = false;
            })
      }
    },
    calculatePriceIfPossible() {
      if(this.misc && this.misc.priceNet && this.misc.taxPercent) {
        this.misc.tax = this.misc.priceNet * this.misc.taxPercent / 100
        this.misc.price = this.misc.priceNet + this.misc.tax;
      }
    },
    updateShowModal(value) {
      this.$emit('update:show-modal', value);
    }
  },
  watch: {
    showModal: {
      immediate: true,
      handler: function(showModal) {
        this.validationErrors = {};
          if(showModal) {
            this.misc = Object.assign(this.getDefaultMisc(), this.convertMisc(this.initialBookingMisc));
          }
      }
    }
  }
}
</script>
